"use strict";
/**
 * User domain models
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoles = void 0;
/**
 * User roles
 */
exports.UserRoles = ["USER", "ADMIN"];
//# sourceMappingURL=user.js.map